/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Nav_Theme_LightInputs */

const en_common_nav_theme_light = /** @type {(inputs: Common_Nav_Theme_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Light`)
};

const zh_common_nav_theme_light = /** @type {(inputs: Common_Nav_Theme_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浅色模式`)
};

/**
* | output |
* | --- |
* | "Light" |
*
* @param {Common_Nav_Theme_LightInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_nav_theme_light = /** @type {((inputs?: Common_Nav_Theme_LightInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Nav_Theme_LightInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_nav_theme_light(inputs)
	return zh_common_nav_theme_light(inputs)
});
export { common_nav_theme_light as "common.nav.theme_light" }